export enum EstadoModificacion {
    Pendiente = 0,
	Aprobado = 1,
	Rechazado = 2
}